import { Component, OnInit } from '@angular/core';
import { ElasticserviceService } from 'src/app/shared/services/elasticservice.service';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MatSnackBar } from "@angular/material/snack-bar";
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { constants } from 'src/app/shared/common/contants';

@Component({
    selector: 'app-elasticsearch',
    templateUrl: './elasticsearch.component.html',
    styleUrls: ['./elasticsearch.component.scss'],
    standalone: false
})
export class ElasticsearchComponent implements OnInit {

  search;
  elastciresponse:any;
  elasticFilterResponse:any;
  converted:any=[];
  filterConverted:any=[];
  eachconverted:any;
  filtereachconverted:any;
  studyCondition=false;
  filterCondition=false;
  productCondition=false;
  seriousnessCondition=false;
  from:number=0;
  size:number=100;
  sizeCount;
  totalCount;
  totalSizeCount;
  studyFilter:any=[];
  reportFilter:any=[];
  productFilter:any=[];
  seriousnessFilter:any=[];
  totalFIlters:any=[];
  finaltotalFilters:String;
  getdata: any = []
  columnDefs
  rowData
  gridApi
  rowClassRules
  defaultColDef
  rowSelection
  paginationNumberFormatter;
  private gridColumnApi;
  grid
  totalobjectfilters:any=[]
  elasticObject = {studycheck:[],productcheck:[],reportTypecheck:[],seriousnesscheck:[]}
  components 
  add;
  minus;
  filters;
  backgroundColorScreen="";
  buttonColor="";
  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  gridColumnAPI;

  paginationPageSize;

  pageSize;

  value;

  overlayNoRowsTemplate;
  productname:any
  constructor( private service:ElasticserviceService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar,private localStorageSettings: LocalStorageSettingsService,private constants: constants) { }

  ngOnInit() {
    // array to bind data to ag grid this.validation.equalto("password")
    this.columnDefs = [
      { headerName: 'Name', headerTooltip: 'Name', tooltipValueGetter: (params) => 'Name : ' + params.value, field: 'name__v', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Patient Id', headerTooltip: 'Patient Id', tooltipValueGetter: (params) => 'Patient Id : ' + params.value, field: 'patient_id_value__v', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Id', headerTooltip: 'Id', tooltipValueGetter: (params) => 'Id : ' + params.value, field: 'id', filter: 'agTextColumnFilter', width: 250 }, 
      { headerName: 'Product', headerTooltip: 'Product', tooltipValueGetter: (params) => 'Product : ' + params.value, field: 'product', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Study', headerTooltip: 'Study', tooltipValueGetter: (params) => 'Study : ' + params.value, field: 'study_name__v', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Report Type', headerTooltip: 'Report Type', tooltipValueGetter: (params) => 'Report Type : ' + params.value, field: 'report_type__v', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Reported Due to', headerTooltip: 'Reported Due to', tooltipValueGetter: (params) => 'Reported Due to : ' + params.value, field: 'event_reported__v', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Age', headerTooltip: 'Age', tooltipValueGetter: (params) => 'Age : ' + params.value, field: 'age_value__v', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Seriousness', headerTooltip: 'Seriousness', tooltipValueGetter: (params) => 'Seriousness : ' + params.value, field: 'serious__v', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Created Date', headerTooltip: 'Created Date', tooltipValueGetter: (params) => 'Created Date : ' + params.value, field: 'created_date__v', filter: 'agTextColumnFilter', width: 250 },
      
    ]
    // if the record has status==no , row color will change
    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },

    };


    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = "100";
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };


    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }
 //excel export function
 onBtExport() {

  this.gridApi.exportDataAsCsv();

}

//pagination code
onPaginationChanged() {

  if (this.gridApi) {

    this.lastPage = this.gridApi.paginationIsLastPageFound();

    this.currentPage = this.gridApi.paginationGetCurrentPage() + 1

    this.nextPage = this.gridApi.paginationGetCurrentPage() + 1 + 1

    this.nextPagePlusOne = this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1

    this.totalPages = this.gridApi.paginationGetTotalPages()

  }

}

//this function is for going to the given page number 
onSearchChange(e) {
  console.log(e.target.value)
  let searchValue = e.target.value
  let searchNumber:number = searchValue;
  if(searchNumber>100){
  this.from=0;
  console.log(searchNumber)
  this.size= 100;
  this.from = searchNumber-100;
  this.onGridReady(this.grid,this.from,this.size,this.finaltotalFilters);
  //this.from = 0;
  }
  else if(e.target.value===""){
    this.from=0;
    this.size= 100;
    this.onGridReady(this.grid,this.from,this.size,this.finaltotalFilters);
  }
  //this.gridApi.paginationGoToPage(searchNumber - 1);

}

// below function is for changing the no of rows per page
onPageSizeChanged(newPageSize) {
  console.log(this.pageSize)
  this.size= this.pageSize;
  this.onGridReady(this.grid,this.from,this.size,this.finaltotalFilters);

   var value = this.pageSize;

   this.gridApi.setGridOption('paginationPageSize', Number(value));

}

// below function is for going to next page
async onBtNext() {

  /*this.recordsStart = this.recordsStart + 100;

  this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

  console.log(this.retrieveObject);

  if (this.retrieveObject.length == 0) {

    this.recordsStart = this.recordsStart - 100;

  }

  else {

    this.gridApi.setGridOption('rowData', this.retrieveObject);

  }*/

  this.gridApi.paginationGoToNextPage();

}

// below function for going to previous page
async onBtPrevious() {

  /*if (this.recordsStart > 0) {

    this.recordsStart = this.recordsStart - 100;

    this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

    console.log(this.retrieveObject);

    this.gridApi.setGridOption('rowData', this.retrieveObject);

  }*/

  this.gridApi.paginationGoToPreviousPage();

}

// below function for going to first page
onBtFirst() {
  this.size= 100;
  this.from = 0;
  this.onGridReady(this.grid,this.from,this.size,this.finaltotalFilters);

  //this.gridApi.paginationGoToFirstPage();
}

// below function for going to last page
onBtLast() {
  this.from=0;
  this.size= 100;
  let totalnumber:number = this.totalCount;
  console.log(totalnumber)
  this.from = this.totalCount-100;  
  this.onGridReady(this.grid,this.from,this.size,this.finaltotalFilters);
  //this.gridApi.paginationGoToLastPage();

}

  //pagination code ends

  // below function is to load the ag grid
  onGridReady(params,add,size,filters) {
    console.log(params)
    size=this.size;
    let add1 = this.from;
    console.log("service")
    let res: any
    this.grid = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //this.gridApi.sizeColumnsToFit();
      this.service.retrievelasticService(add1,size,filters).subscribe(res => {
        console.log(res)
        this.studyFilter=[];
        this.reportFilter=[];
        this.productFilter=[];
        this.seriousnessFilter=[];
        this.elastciresponse=[]
        this.totalCount=0;
        this.eachconverted={};
        this.converted=[];
        this.getdata=[];
        this.totalobjectfilters=[];
  
        this.spinner.start();
  
        // checking if response is true or not
        if (res.error === true) {
  
          this.spinner.stop();
  
          this.snackbar.open("no data found", "OK", { duration: 5000 });
  
        } else {
          this.spinner.stop();
          //console.log(res)
          this.elastciresponse = res
           this.totalCount = this.elastciresponse.hits.total.value;
          for(let i = 0 ; i< this.elastciresponse.hits.hits.length;i++){
            if(this.elastciresponse.hits.hits[i]._source.message !== undefined){
              this.productname="";
              this.eachconverted = JSON.parse(this.elastciresponse.hits.hits[i]._source.message)
             //this.converted.push(this.eachconverted)
             if(this.eachconverted.case_product__v !== undefined){
              let product__v="";
             for(let p=0 ; p< this.eachconverted.case_product__v.length;p++){
              if(this.eachconverted.case_product__v[p].product_name__v != ""){
                if(product__v===""){
                  product__v = this.eachconverted.case_product__v[p].product_name__v;
                }else{
                product__v = product__v+","+ this.eachconverted.case_product__v[p].product_name__v;
                }
                this.productname = {"product":product__v};
                if(this.productFilter.some(check=>check.object === this.eachconverted.case_product__v[p].product_name__v)===false){
                  if(this.totalFIlters.includes(this.eachconverted.case_product__v[p].product_name__v)){
                    this.productFilter.push({object:this.eachconverted.case_product__v[p].product_name__v,checkedorunchecked:true})
                this.totalobjectfilters.push(this.eachconverted.case_product__v[p].product_name__v)
                  }else{
                this.productFilter.push({object:this.eachconverted.case_product__v[p].product_name__v,checkedorunchecked:false})
                this.totalobjectfilters.push(this.eachconverted.case_product__v[p].product_name__v)
                  }
                }
              }
             }
            }
            let obj = {...this.eachconverted,...this.productname};
            console.log(obj)
            this.converted.push(obj)

           // Array.prototype.concat(this.converted,[this.eachconverted,this.productname])
            console.log(this.converted)

  
             if(this.eachconverted.study_name__v != ""){
               if(this.studyFilter.some(check=>check.object === this.eachconverted.study_name__v)===false){
                 if(this.totalFIlters.includes(this.eachconverted.study_name__v)){
                  this.studyFilter.push({object:this.eachconverted.study_name__v,checkedorunchecked:true})
                  this.totalobjectfilters.push(this.eachconverted.study_name__v)
                 }else{
                this.studyFilter.push({object:this.eachconverted.study_name__v,checkedorunchecked:false})
                this.totalobjectfilters.push(this.eachconverted.study_name__v)
                 }
               }
             }
            //  if(this.eachconverted.report_type__v != ""){
            //    if(this.reportFilter.some(check=>check.object === this.eachconverted.report_type__v)===false){
            //      if(this.totalFIlters.includes(this.eachconverted.report_type__v)){
            //       this.reportFilter.push({object:this.eachconverted.report_type__v,checkedorunchecked:true})
            //       this.totalobjectfilters.push(this.eachconverted.report_type__v)
            //      }else{
            //   this.reportFilter.push({object:this.eachconverted.report_type__v,checkedorunchecked:false})
            //   this.totalobjectfilters.push(this.eachconverted.report_type__v)
            //      }
            //    }
            // }
            if(this.eachconverted.serious__v != ""){
              if(this.seriousnessFilter.some(check=>check.object === this.eachconverted.serious__v)===false){
                if(this.totalFIlters.includes(this.eachconverted.serious__v)){
                  this.seriousnessFilter.push({object:this.eachconverted.serious__v,checkedorunchecked:true})
                  this.totalobjectfilters.push(this.eachconverted.serious__v)    
                }else{
              this.seriousnessFilter.push({object:this.eachconverted.serious__v,checkedorunchecked:false})
              this.totalobjectfilters.push(this.eachconverted.serious__v)
                }
              }
            }
             this.sizeCount=i+1;
          }
            //console.log(this.converted)
          }
          this.totalSizeCount = this.sizeCount;
          this.size = this.totalSizeCount;

          console.log(this.converted)
          if(this.converted.length!==0){
            this.from = this.from + this.totalSizeCount;
          }else{
            this.from=0;
          }
          this.getdata = this.converted
        this.gridApi.setGridOption('rowData', this.getdata)
  
        }
  
      });
      
    params.api.expandAll();
    window.onresize = () => {
      this.gridApi.sizeColumnsToFit();
   
    
  }
}

 

  next(){
     if(this.from>this.totalCount){

     }else{
     this.size= 100;
     this.onGridReady(this.grid,this.from,this.size,this.finaltotalFilters);
     }
     console.log(this.from)
     console.log(this.size)
 
  }

  pre(){
     if(this.from==0){

     }
     else{
      this.size= 100;
      this.from = this.from-100;
      if(this.from<=100){
        this.from=0;
        this.onGridReady(this.grid,this.from,this.size,this.finaltotalFilters);   
      }else{
     this.onGridReady(this.grid,this.from,this.size,this.finaltotalFilters);
      }
     }
     console.log(this.from)
     console.log(this.size)
  }




  study(){
    if(this.studyCondition===false){
      this.studyCondition=true
    }else{
      this.studyCondition=false
    }
  }
  report(){
    if(this.filterCondition===false){
      this.filterCondition=true
    }else{
      this.filterCondition=false
    }
  }
  product(){
    if(this.productCondition===false){
      this.productCondition=true
    }else{
      this.productCondition=false
    }
  }
  Seriousness(){
    if(this.seriousnessCondition===false){
      this.seriousnessCondition=true
    }else{
      this.seriousnessCondition=false
    }
  }

  checked(e,value){
    let studyc:any=[];
    console.log(e)
    console.log(this.totalobjectfilters)
    if(e.checked===true){
      this.totalobjectfilters.forEach((d: any) => {
        console.log(d)
        console.log(value.object)
        if(d === value.object) {
          console.log(value.object)
          this.totalFIlters.push(value.object)
        }
      });
    }else{
      this.totalFIlters.forEach((element,i)=>{
        if(value.object==element)
        this.totalFIlters.splice(i,1);
      });
    }
    console.log(this.totalFIlters)
     this.finaltotalFilters = this.totalFIlters.toString();
     console.log(this.finaltotalFilters)
     this.finaltotalFilters = this.finaltotalFilters.replace("\"", "").replace(",", " ");
     console.log(this.finaltotalFilters);
     this.size=100;
    this.from=0;
    this.onGridReady(this.grid,this.from,this.size,this.finaltotalFilters);
     
  }

  clearSelected(){
    this.totalFIlters=[]
    this.finaltotalFilters="";
    this.studyFilter.forEach(e=>{
      e.checkedorunchecked=false;
    });
    this.reportFilter.forEach(e=>{
      e.checkedorunchecked=false;
    });
    this.productFilter.forEach(e=>{
      e.checkedorunchecked=false;
    });
    this.seriousnessFilter.forEach(e=>{
      e.checkedorunchecked=false;
    });
    this.from = 0;
    this.size=100
    this.onGridReady(this.grid,this.from,this.size,this.finaltotalFilters);
  }

  }